import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'c4g-page-dropdown',
  templateUrl: './page-dropdown.component.html',
  styleUrls: ['./page-dropdown.component.scss']
})
export class PageDropdownComponent {
  @Input() values: any[] = [];
  @Input() selected: any;
  @Input() disabled = false;
  @Input() displayWith?: (value: any) => string;
  @Output() valueChange = new EventEmitter<any>();

  open = false;

  toggleDropdown() {
    if (!this.disabled) {
      this.open = !this.open;
    }
  }

  selectValue(value: any) {
    this.valueChange.emit(value);
    this.open = false;
  }

  getDisplay(value: any): string {
    return this.displayWith ? this.displayWith(value) : String(value);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!(event.target as HTMLElement).closest('.c4g-page-dropdown')) {
      this.open = false;
    }
  }
}
